<div class="card mt-4">
    <div class="card-body pt-4">
        <app-subtitle-hr [title]="'Kilómetros y frenadas bruscas | Shell'" />
        <i class="pi pi-angle-down button-float" [ngClass]="{'rotate-button': rotate}" (click)="hide()"></i>

        <div class="hide-container" [ngClass]="{'show-container': show}">
            <div>

                <div id="main-shell" style="width: 100%; height: 404px;"></div>

                <div class="table-container">
                    <table class="tg mt-3">
                        <thead>
                            <tr>
                                <th style="border: none;"></th>
                                <th class="total-table-top" *ngFor="let m of meses">{{ m.nameES }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="total-table-hs">
                                <td class="tg-0lax top-table">Kilómetros</td>
                                <td class="tg-0lax top-table" *ngFor="let m of meses">
                                    {{ getValue(m.id, kmType.km) }}
                                </td>
                            </tr>
                            <tr class="total-table">
                                <td class="tg-0lax top-table">Frenadas bruscas</td>
                                <td class="tg-0lax top-table" *ngFor="let m of meses">
                                    {{ getValue(m.id, kmType.frenadas) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>